const Skeleton = ({ style = {} }) => {
	return (
		<div
			className="skeleton"
			style={style}
		></div>
	);
};

export default Skeleton;
